var map = {
	"./apteka.svg": [
		"nag3",
		39
	],
	"./avito-nedv.svg": [
		"r3oy",
		40
	],
	"./cian.svg": [
		"vMaa",
		41
	],
	"./market.svg": [
		"UWPk",
		42
	],
	"./oskolenergo.svg": [
		"inmx",
		43
	],
	"./serpure.svg": [
		"GYhA",
		44
	],
	"./wildberries.svg": [
		"djNs",
		45
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7KUT";
module.exports = webpackAsyncContext;